export default __webpack_public_path__ + "static/media/depositWithdrawalIcon3.10308920.webp";